import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';
import { MatTableDataSource } from '@angular/material/table';
import { ClientItem } from 'src/app/model/client-item';
import { MSSPService } from 'src/app/services/mssp.service';
import { StorageService } from 'src/app/services/storage.service';
import { CommonService } from 'src/app/services/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { RegisterDevice } from 'src/app/model/register-device';
import localeEs from '@angular/common/locales/es'
import { registerLocaleData } from '@angular/common';
registerLocaleData(localeEs, 'es');
import { RequestIntegrationItem } from 'src/app/model/client-policy-detail';

@Component({
  selector: 'app-device-history',
  templateUrl: './device-history.component.html',
  styleUrls: ['./device-history.component.scss']
})
export class DeviceHistoryComponent implements OnInit {
  @ViewChild(MatAccordion) accordion!: MatAccordion;
  @Input() device!:RequestIntegrationItem;
  @Input() claimHistory!: any[] ;

  itemopen: boolean = false;
  displayedColumns: any[] = ["Evento"];
     
  constructor(
    private storageService:StorageService
  ) { 

  }

  ngOnInit(): void {}

  toggle(){
    this.itemopen = !this.itemopen;
  }
}
